// extracted by mini-css-extract-plugin
export default {"tags":"tags_tags__ZAh2Y"};